import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root', // Ensures the service is available app-wide
})

export class CommonService {
  // auto
  private authFooterHeightSource = new BehaviorSubject<number>(0); // Initial value is 0
  authFooterHeight$ = this.authFooterHeightSource.asObservable(); // Observable for subscribers

  isWebPSupported(): boolean {
    let useWebp = false;

    if (typeof document === 'object') {
      // Client side rendering
      const canvas = document.createElement('canvas');

      if (
        canvas?.getContext &&
        canvas?.getContext('2d') &&
        canvas?.toDataURL('image/webp').indexOf('data:image/webp') === 0
      ) {
        useWebp = true;
      }
    }

    return useWebp;
  }

  // Method to update the height
  setAuthFooterHeight(height: number): void {
    this.authFooterHeightSource.next(height);
  }

  getAuthFooterHeight() : number {
    return this.authFooterHeightSource.getValue();
  }

}
